import { render, staticRenderFns } from "./campusDiscount.vue?vue&type=template&id=4790de91&scoped=true"
import script from "./campusDiscount.vue?vue&type=script&lang=js"
export * from "./campusDiscount.vue?vue&type=script&lang=js"
import style0 from "./campusDiscount.vue?vue&type=style&index=0&id=4790de91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4790de91",
  null
  
)

export default component.exports